import axios from '../api/axiosInstance';

export const fetchDeliveryBoyLogins = (params) => {
  return axios.get('/delivery-boy-logins', { params });
};

export const updateDeliveryBoyLogin = (id, data) => {
  return axios.put(`/delivery-boy-logins/${id}`, data);
};
